import React, { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
// import { useMediaQuery } from "@mui/material";

import { getAnalytics } from "../../redux/slices/reportSlice";
import { useDispatch, useSelector } from "react-redux";

const Linechart = () => {
  // const isTab = useMediaQuery("(max-width:867px)");
  // const isMobile = useMediaQuery("(max-width:567px)");
  const dispatch = useDispatch();
  const { analytics } = useSelector((state) => state.report);

  useEffect(() => {
    dispatch(getAnalytics());
  }, [dispatch]);
  //console.log(analytics)

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Transforming the API data
  const data =
    analytics && analytics.camapigns
      ? analytics.camapigns.map((campaign, index) => ({
          name: monthNames[index], // Month name
          // Advertisers: analytics.advertisers.advertiser[index]?.advertiserCount || 0,
          // Campaigns: campaign.campaignCount || 0,
          Conversions:
            analytics.conversions.conversions[index]?.conversioncount || 0,
        }))
      : [] ;
  // Dummy data
  // const data = [
  //   { name: "Jan", Advertisers: 200, Campaigns: 400, Conversions: 600 },
  //   { name: "Feb", Advertisers: 260, Campaigns: 420, Conversions: 520 },
  //   { name: "Mar", Advertisers: 230, Campaigns: 390, Conversions: 530 },
  //   { name: "Apr", Advertisers: 280, Campaigns: 350, Conversions: 650 },
  //   { name: "May", Advertisers: 260, Campaigns: 360, Conversions: 560 },
  //   { name: "Jun", Advertisers: 270, Campaigns: 440, Conversions: 670 },
  //   { name: "Jul", Advertisers: 290, Campaigns: 390, Conversions: 690 },
  //   { name: "Aug", Advertisers: 270, Campaigns: 400, Conversions: 600 },
  //   { name: "Sep", Advertisers: 320, Campaigns: 420, Conversions: 620 },
  //   { name: "Oct", Advertisers: 340, Campaigns: 440, Conversions: 540 },
  //   { name: "Nov", Advertisers: 360, Campaigns: 480, Conversions: 660 },
  //   { name: "Dec", Advertisers: 320, Campaigns: 390, Conversions: 680 }
  // ];

  const formatCurrency = (tick) => {
    if (tick >= 1000000) return `${tick / 1000000}m`;
    if (tick >= 1000) return `${tick / 1000}k`;
    return tick;
  };

  return (
    <div style={{ marginLeft: "-30px", marginTop: "30px" }}>
      <ResponsiveContainer width="100%" height={334}>
        <BarChart 
          data={data}
          margin={{ top: 20, right: 20, left: 0, bottom: 0 }}
          barSize={32}
        >
          {/* Gradient definition for each area */}
          {/* <defs>
            <linearGradient id="AdvertisersGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="CampaignsGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
            <linearGradient
              id="ConversionsGradient"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
              <stop offset="0%" stopColor="#00A087" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
            </linearGradient>
          </defs> */}

          <CartesianGrid vertical={false} stroke="#e3f2fd" />
          <XAxis
            dataKey="name"
            stroke="#9C9C9C"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            stroke="#9C9C9C"
            fontSize={10}
            fontWeight={300}
            minTickGap={1}
            tickFormatter={formatCurrency}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip 
            contentStyle={{
              borderRadius: 12,
              border: "1px solid #e3f2fd",
              boxShadow: "0 4px 12px rgba(3, 169, 244, 0.12)",
              padding: "10px 14px",
            }}
            formatter={(value, name) => {
              if (name === "Conversions") {
                return [value.toLocaleString(), name];
              }
              return [value, name];
            }}
          />
          <Legend 
            verticalAlign="top" 
            height={36} 
            wrapperStyle={{ paddingBottom: 10 }}
          />

          {/* Areas with gradient fills */}
          {/* <Area
            type="monotone"
            dataKey="Advertisers"
            stroke="#00A38A"
            strokeWidth={2}
            fill="url(#AdvertisersGradient)"
          />
          <Area
            type="monotone"
            dataKey="Campaigns"
            stroke="#00D1B1"
            strokeWidth={2}
            fill="url(#CampaignsGradient)"
          /> */}
          <Bar
            type="monotone"
            dataKey="Conversions"
            fill="#81d4fa"
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Linechart;
